import { render, staticRenderFns } from "./reporteinstitucion.vue?vue&type=template&id=4909591c"
import script from "./reporteinstitucion.vue?vue&type=script&lang=js"
export * from "./reporteinstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports